export default __webpack_public_path__ + "static/media/partners14.0dbadd7e.png";